import _ from 'lodash';
import { Key } from '../samwebDescription/samweb/shortcuts/Keys';

export function shortcutStringBuilderFromKeyboardEvent(keyboardEvent: KeyboardEvent): string {
   // filter out function keys
   if (
      keyboardEvent.key === 'Alt' ||
      keyboardEvent.key === 'Control' ||
      keyboardEvent.key === 'Meta' ||
      keyboardEvent.key === 'Shift' ||
      keyboardEvent.key === 'AltGraph'
   ) {
      return '';
   }

   const keys: string[] = [];
   if (keyboardEvent.ctrlKey) {
      keys.push(Key.Ctrl);
   }
   if (keyboardEvent.altKey) {
      keys.push(Key.Alt);
   }
   if (keyboardEvent.metaKey) {
      keys.push(Key.Meta);
   }
   if (keyboardEvent.shiftKey) {
      keys.push(Key.Shift);
   }

   // map the key to the human readable interpretation, some keys require special handling to
   // respect language based differences in keyboard layout (best guess)
   // Note: they must map to constant defined in Key-Class (which we use for the configuration)
   let key = null;
   // German keyboard: Shift + #
   // tslint:disable-next-line: quotemark
   if (keyboardEvent.shiftKey && keyboardEvent.code === 'BracketRight' && keyboardEvent.key === "'") {
      key = Key.Pound;
      // German keyboard: Shift + +
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Backslash' && keyboardEvent.key === '*') {
      key = Key.Plus;
      // German keyboard: Shift + -
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Slash' && keyboardEvent.key === '_') {
      key = Key.Minus;
      // German keyboard: Shift + -
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'IntlBackslash' && keyboardEvent.key === '>') {
      key = Key.LowerThan;
      // German keyboard: Shift + ^
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Backquote' && keyboardEvent.key === '°') {
      key = Key.Caret;
      // German keyboard: Shift + ´
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Backquote' && keyboardEvent.key === 'Dead') {
      key = Key.Dead;
      // German keyboard: Shift + ß
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Minus' && keyboardEvent.key === '?') {
      key = Key.Eszet;
      // German keyboard: Ctrl + Alt + Q
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'KeyQ' && keyboardEvent.key === '@') {
      key = Key.KeyQ;
      // German keyboard: AltGr + Q
   } else if (keyboardEvent.code === 'KeyQ' && keyboardEvent.key === '@') {
      keys.push(Key.AltGr);
      key = Key.KeyQ;
      // German keyboard: Ctrl + Alt + M
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'KeyM' && keyboardEvent.key === 'µ') {
      key = Key.KeyM;
      // German keyboard: AltGr + M
   } else if (keyboardEvent.code === 'KeyM' && keyboardEvent.key === 'µ') {
      keys.push(Key.AltGr);
      key = Key.KeyM;
      // German keyboard: Ctrl + Alt + < (pipe)
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'IntlBackslash' && keyboardEvent.key === '|') {
      key = Key.LowerThan;
      // German keyboard: AltGr + < (pipe)
   } else if (keyboardEvent.code === 'IntlBackslash' && keyboardEvent.key === '|') {
      keys.push(Key.AltGr);
      key = Key.LowerThan;
      // German keyboard: Ctrl + Alt + E
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'KeyE' && keyboardEvent.key === '€') {
      key = Key.KeyE;
      // German keyboard: AltGr + E
   } else if (keyboardEvent.code === 'KeyE' && keyboardEvent.key === '€') {
      keys.push(Key.AltGr);
      key = Key.KeyE;
      // German keyboard: Ctrl + Alt + +
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'BracketRight' && keyboardEvent.key === '~') {
      key = Key.Plus;
      // German keyboard: AltGr + +
   } else if (keyboardEvent.code === 'BracketRight' && keyboardEvent.key === '~') {
      keys.push(Key.AltGr);
      key = Key.Plus;
      // German keyboard: Ctrl + Alt + 7
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'Digit7' && keyboardEvent.key === '{') {
      key = Key.Digit7;
      // German keyboard: AltGr + 7
   } else if (keyboardEvent.code === 'Digit7' && keyboardEvent.key === '{') {
      keys.push(Key.AltGr);
      key = Key.Digit7;
      // German keyboard: Ctrl + Alt + 8
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'Digit8' && keyboardEvent.key === '[') {
      key = Key.Digit8;
      // German keyboard: AltGr + 8
   } else if (keyboardEvent.code === 'Digit8' && keyboardEvent.key === '[') {
      keys.push(Key.AltGr);
      key = Key.Digit8;
      // German keyboard: Ctrl + Alt + 9
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'Digit9' && keyboardEvent.key === ']') {
      key = Key.Digit9;
      // German keyboard: AltGr + 9
   } else if (keyboardEvent.code === 'Digit9' && keyboardEvent.key === ']') {
      keys.push(Key.AltGr);
      key = Key.Digit9;
      // German keyboard: Ctrl + Alt + 0
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'Digit0' && keyboardEvent.key === '}') {
      key = Key.Digit0;
      // German keyboard: AltGr + 0
   } else if (keyboardEvent.code === 'Digit0' && keyboardEvent.key === '}') {
      keys.push(Key.AltGr);
      key = Key.Digit0;
      // German keyboard: Ctrl + Alt + ß
   } else if (keyboardEvent.ctrlKey && keyboardEvent.altKey && keyboardEvent.code === 'Minus' && keyboardEvent.key === '\\') {
      key = Key.Eszet;
      // German keyboard: AltGr + ß
   } else if (keyboardEvent.code === 'Minus' && keyboardEvent.key === '\\') {
      keys.push(Key.AltGr);
      key = Key.Eszet;
      // German keyboard: ä
   } else if (keyboardEvent.code === 'Quote' && keyboardEvent.key === 'ä') {
      key = Key.KeyAe;
      // German keyboard: ö
   } else if (keyboardEvent.code === 'Semicolon' && keyboardEvent.key === 'ö') {
      key = Key.KeyOe;
      // German keyboard: ü
   } else if (keyboardEvent.code === 'BracketLeft' && keyboardEvent.key === 'ü') {
      key = Key.KeyUe;
      // German keyboard: Shift + .
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Period' && keyboardEvent.key === ':') {
      key = Key.Dot;
      // German keyboard: Shift + ,
   } else if (keyboardEvent.shiftKey && keyboardEvent.code === 'Comma' && keyboardEvent.key === ';') {
      key = Key.Comma;
      // Unified mapping for DigitX to X
   } else if (_.startsWith(keyboardEvent.code, 'Digit')) {
      key = keyboardEvent.code.substr(5);
      // Unified mapping for KeyX to X
   } else if (_.startsWith(keyboardEvent.code, 'Key')) {
      key = keyboardEvent.code.substr(3);
      // Unified mapping for Numpad keys
   } else if (_.startsWith(keyboardEvent.code, 'Numpad')) {
      key = keyboardEvent.code.substr(6) + ' (Numpad)';
      // Unified mapping for Arrow keys
   } else if (_.startsWith(keyboardEvent.code, 'Arrow')) {
      key = keyboardEvent.code.substr(5);
   } else {
      key = keyboardEvent.key;
   }
   keys.push(key);

   return shortcutStringBuilder(...keys);
}

export function shortcutStringBuilder(...keys: string[]): string {
   // order should be control+alt+shift+button
   const keyCodes = _(keys).uniq();
   const sanitizedKeys: string[] = [];

   if (keyCodes.includes(Key.Ctrl)) {
      sanitizedKeys.push(Key.Ctrl);
   }
   if (keyCodes.includes(Key.Alt)) {
      sanitizedKeys.push(Key.Alt);
   }
   if (keyCodes.includes(Key.Meta)) {
      sanitizedKeys.push(Key.Meta);
   }
   if (keyCodes.includes(Key.Shift)) {
      sanitizedKeys.push(Key.Shift);
   }

   keyCodes.difference([Key.Ctrl, Key.Alt, Key.Meta, Key.Shift]).forEach((k) => sanitizedKeys.push(k));

   return _(sanitizedKeys).join(' + ');
}
